/**
 * 虚拟键盘 key map
 * 移动设备上模拟输入键,现有 4 行
 */
export const NumberKeyMap = [
    [
        {
            key: 'Backquote',
            title: '`',
            subTitle: '~',
        },
        {
            key: 'Digit1',
            title: '1',
            subTitle: '!',
        },
        {
            key: 'Digit2',
            title: '2',
            subTitle: '@',
        },
        {
            key: 'Digit3',
            title: '3',
            subTitle: '#',
        },
        {
            key: 'Digit4',
            title: '4',
            subTitle: '$',
        },
        {
            key: 'Digit5',
            title: '5',
            subTitle: '%',
        },
        {
            key: 'Digit6',
            title: '6',
            subTitle: '^',
        },
        {
            key: 'Digit7',
            title: '7',
            subTitle: '&',
        },
        {
            key: 'Digit8',
            title: '8',
            subTitle: '*',
        },
        {
            key: 'Digit9',
            title: '9',
            subTitle: '(',
        },
        {
            key: 'Digit0',
            title: '0',
            subTitle: ')',
        },
    ],
    [
        {
            key: 'Minus',
            title: '-',
            subTitle: '_',
        },
        {
            key: 'Equal',
            title: '=',
            subTitle: '+',
        },
        {
            key: 'BracketLeft',
            title: '[',
            subTitle: '{',
        },
        {
            key: 'BracketRight',
            title: ']',
            subTitle: '}',
        },
        {
            key: 'Backslash',
            title: '\\',
            subTitle: '|',
        },
        {
            key: 'Semicolon',
            title: ';',
            subTitle: ':',
        },
        {
            key: 'Quote',
            title: ',',
            subTitle: '"',
        },
        {
            key: 'Comma',
            title: ',',
            subTitle: '<',
        },
        {
            key: 'Period',
            title: '.',
            subTitle: '>',
        },
        {
            key: 'Slash',
            title: '/',
            subTitle: '?',
        }
    ],
    [
        {
            key: 'F1',
            title: 'F1',
        },
        {
            key: 'F2',
            title: 'F2',
        },
        {
            key: 'F3',
            title: 'F3',
        }, 
        {
            key: 'F4',
            title: 'F4',
        }, 
        {
            key: 'F5',
            title: 'F5',
        }, 
        {
            key: 'F6',
            title: 'F6',
        }, 
        {
            key: 'F7',
            title: 'F7',
        }, 
        {
            key: 'F8',
            title: 'F8',
        },
    ],
    [
        {
            key: 'F9',
            title: 'F9',
        },
        {
            key: 'F10',
            title: 'F10',
        },
        {
            key: 'F11',
            title: 'F11',
        },
        {
            key: 'F12',
            title: 'F12',
        },
    ]
]